/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { ReactComponent as ArrowBackIcon } from '../../assets/images/arrow_back_24px.svg';
import { me as meSlice } from '../../pages/AuthenticatedPage/authenticationSlice';
import { t } from '../../providers';
import sidebarItems from './sidebarItems';
import { viewableItems } from './utils';

const useStyles = makeStyles((theme) => ({
    sidebar: {
        marginTop: '0px',
        height: '100%',
        display: 'flex',
        flexFlow: 'row nowrap',
    },
    backArrow: {
        width: '25px',
    },
    sidebarBody: {
        padding: '0 15px',
        width: '100%',
    },
    sidebarHeader: {
        marginBottom: '40px',
    },
    sidebarTitle: {
        color: '#00294E',
        fontWeight: theme.typography.titleFontWeight,
        fontSize: theme.typography.titleFontSize,
        letterSpacing: '0',
        lineHeight: '20px',
    },
    sidebarSubtitle: {
        color: theme.palette.text.outlined,
        fontSize: '10px',
        fontWeight: '600',
        textTransform: 'uppercase',
        lineHeight: '20px',
    },
    sidebarOptions: { width: '100%' },
    sidebarOption: {
        position: 'relative',
        margin: '20px 0 0 19px',
        width: '100%',
    },
    sidebarOptionIcon: {
        width: '20px',
        position: 'absolute',
        top: '2px',
        left: '-19px',
    },
    selectedOption: {
        color: theme.palette.text.mainBlue,
        fontWeight: 'bold',
        fontSize: '14px',
        lineHeight: '20px',
    },
    cursorPointer: {
        cursor: 'pointer',
    },
    sidebarOptionTitle: {
        fontSize: '14px',
        lineHeight: '20px',
    },
    selectedSubmenuOption: {
        color: theme.palette.text.mainBlue,
        fontWeight: '600',
        lineHeight: '20px',
        fontSize: '14px',
    },
    submenuOption: {
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        marginTop: '20px',
    },
    rightArrowIcon: {
        marginRight: '10px',
    },
    notSelectedArrow: {
        '& path': {
            fill: theme.palette.primary.main,
        },
    },
    option: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        position: 'relative',
        '&:hover': {
            cursor: 'pointer',
        },
    },
}));

const Sidebar = ({ smallDevice, handleSidebarVisibility }) => {
    const classes = useStyles();
    const me = useSelector(meSlice);

    let sidebarType = !!(me || {}).userName ? 'auth' : 'unauth';

    const { userType, authorities } = me || {};

    const items = [...sidebarItems[sidebarType]];

    const location = useLocation();
    const history = useHistory();
    const title = {
        main: 'user.area',
    };
    const splittedPath = location.pathname.split('/');
    const rootPath = !!splittedPath.length && `/${splittedPath[1]}`;
    const selectedItem = items.find(({ path }) => path === rootPath);
    title.selected = '';
    if (selectedItem) {
        title.selected = selectedItem.subtitle;
    }

    //set title for forrgotten password page
    title.selected = location.pathname.includes('/forgotten-login') ? 'sign.in' : title.selected;

    // reset token page -- hide sidebarMenu and set sidebar subtitle
    let displaySidebarMenu = true;
    if (location.pathname.includes('/reset/token/')){
        displaySidebarMenu = false;
        title.selected = 'password.reset';
    }
    if (location.pathname.includes('/change-username/token')){
        displaySidebarMenu = false;
        title.selected = 'username.change.sidebar.title';
    }
    


    const navigateTo = (event, path) => {
        event.preventDefault();
        if (smallDevice) {
            handleSidebarVisibility();
        }
        if (path && location.pathname !== path) {
            history.push(path);
        }
    };
    const displayedItems = viewableItems({
        items,
        navigateTo,
        userType,
        authorities,
        rootPath,
        sidebarType,
        classes,
        location,
    });
    return (
        <div className={classes.sidebar}>
            {sidebarType === 'unauth' && (
                <div className={classes.backArrow}>
                    <ArrowBackIcon fontSize="small" />
                </div>
            )}
            <div className={classes.sidebarBody}>
                <div className={classes.sidebarHeader}>
                    <div>
                        <Typography className={classes.sidebarTitle}>{t(title.main)}</Typography>

                        <Typography variant="h6" className={classes.sidebarSubtitle}>
                            {!!title.selected && t(title.selected)}
                        </Typography>
                    </div>
                </div>
                {displaySidebarMenu && <div className={classes.sidebarOptions}>{displayedItems}</div>}
            </div>
        </div>
    );
};

export default Sidebar;
